import React from 'react'
import styled from 'styled-components'

import { flex, colors } from '../../styles'

const Outer = styled.div`
  height: 100vh;
  background: black;
  ${ flex.centerBoth }
`

const Spinner = styled.div`
  height: 2rem;
  width: 2rem;
  border-radius: 0.333rem;
  border: 2px solid ${colors.pinkText};
  box-shadow: 0 0 6px ${colors.pinkText};
  animation: spin 0.6s ease-in-out infinite;
`

export default () => (
  <Outer>
    <Spinner/>
  </Outer>
)



/** WEBPACK FOOTER **
 ** ./src/components/Members/Spinner.js
 **/